import React from 'react';
import '../styles/MobileSettings.css';
import { SelectionChip, Switch } from '../components';
import { GlobalIcon, RoadWaysideIcon } from 'hugeicons-react';
import { colour } from '../styles/GlobalStyles';

function MobileSettings(props) {
    const showHeatmap = props.showHeatmap;
    const setShowHeatmap = props.setShowHeatmap;
    const mapType = props.mapType;
    const setMapType = props.setMapType;
    const neighbourhoodData = props.neighbourhoodData;
    const compTypeOptions = props.compTypeOptions;
    const handleCompTypeSelection = props.handleCompTypeSelection;
    const rawMap = props.rawMap;

    const mapTypeOptions = [
        {
            label: "Road view",
            icon: <RoadWaysideIcon color={colour.gray06} size={14} />,
            value: "roadmap",
            selected: mapType === "roadmap" ? true : false
        },
        {
            label: "Satellite view",
            icon: <GlobalIcon color={colour.gray06} size={14} />,
            value: "satellite",
            selected: mapType === "satellite" ? true : false
        }
    ];

    const toggleSatellite = () => {
        if (rawMap) {
            const newMapType = mapType === "roadmap" ? "satellite" : "roadmap";
            rawMap.setMapTypeId(newMapType);
            setMapType(newMapType);
        }
    };

    return (
        <div className="mobile-settings-container">
            {
                neighbourhoodData !== null &&
                <Switch
                    label={"Show heatmap"}
                    val={showHeatmap}
                    setVal={setShowHeatmap}
                />
            }
            <div className="mobile-settings-map-type-container">
                <span className="body-regular colour-primary">
                    Map layer
                </span>
                <div className="mobile-settings-map-type-options">
                    {
                        mapTypeOptions.map((item, index) =>
                            <SelectionChip
                                label={item.label}
                                selected={item.selected}
                                disabled={false}
                                func={() => toggleSatellite()}
                                index={index}
                                leftIcon={item.icon}
                                rightIcon={null}
                                key={index}
                            />
                        )
                    }
                </div>
            </div>
            {
                compTypeOptions !== null &&
                <div className="comp-type-settings-container">
                    <span className="body-regular colour-primary">
                        Select comp type
                    </span>
                    <div className="comp-type-settings-options-row">
                        {
                            compTypeOptions.map((item, index) =>
                                <SelectionChip
                                    label={item.label}
                                    selected={item.selected}
                                    disabled={false}
                                    func={() => handleCompTypeSelection(item.value)}
                                    index={index}
                                    leftIcon={null}
                                    rightIcon={null}
                                    key={index}
                                />
                            )
                        }
                    </div>
                </div>
            }
        </div>
    );
};

export default MobileSettings;